import { routerApp } from '../app.module';

routerApp.controller('testController',function() {});

